<app-training-record-delete #deleteRecordModal (deleted)="location.back()"></app-training-record-delete>
<app-training-record-reminder #sendReminderForm></app-training-record-reminder>
<app-deprecated-modal-form
    #trainingRecordFormModal
    id="training-record-modal"
    [form]="trainingRecordForm"
    [headerText]="getModelFormTitle() | appTranslate"
    (save)="trainingRecordForm.saveRecord()"
    [hideOnSave]="false"
>
    <app-form-training-record
        #trainingRecordForm
        [record]="record"
        (saveRecordEvent)="onSave()"
        (loading)="trainingRecordFormModal.isLoading = $event"
    ></app-form-training-record>
</app-deprecated-modal-form>

<div class="ui basic segment training-record-show" [class.loading]="isLoading">
    <div class="app-grid">
        <app-header [title]="record.trainingProgram.name" [back]="true" [contextMenu]="!record.isComplete && isAdmin()">
            <app-context-item
                label="{{ 'remind' | translate }}"
                (click)="sendReminder.open(this.record)"
            ></app-context-item>
            <app-context-item
                label="{{ 'delete' | translate }}"
                (click)="deleteRecord.confirm(this.record)"
            ></app-context-item>
            <div class="buttons">
                <ui-button
                    *ngIf="!record.isComplete && canEdit()"
                    type="primary"
                    (click)="trainingRecordFormModal.show()"
                    >{{ 'training.recordCompletion' | translate }}
                </ui-button>
                <span *ngIf="record.isComplete" class="record-completed-at"
                    >Completed {{ record.completedAt | appDate }}</span
                >
            </div>
        </app-header>
    </div>
    <div class="ui segment" *ngIf="record.isComplete">
        <div class="app-grid">
            <h3 class="columns-12">
                Name {{ record.employee.fullName }}
                <span
                    class="record-edit"
                    *ngIf="record.isComplete && canEdit()"
                    (click)="trainingRecordFormModal.show()"
                    >{{ 'edit' | translate }}</span
                >
            </h3>
        </div>
        <div class="record-row app-grid" *ngIf="record.trainingProgram.hasExpirationDate">
            <label class="columns-2 small-columns-12">{{ 'training.expirationDate' | translate }}:</label>
            <span class="columns-10 small-columns-12">{{ record.expirationDate | appDate }}</span>
        </div>
        <div class="record-row app-grid" *ngIf="record.trainingProgram.hasInstructor">
            <label class="columns-2 small-columns-12">{{ 'training.instructor' | translate }}:</label>
            <span class="columns-10 small-columns-12">{{ record.instructor }}</span>
        </div>
        <div class="record-row app-grid" *ngIf="record.trainingProgram.hasHours">
            <label class="columns-2 small-columns-12">{{ 'training.hours' | translate }}:</label>
            <span class="columns-10 small-columns-12">{{ record.hours }}</span>
        </div>
        <div class="record-row app-grid" *ngIf="record.trainingProgram.hasCredits">
            <label class="columns-2 small-columns-12">{{ 'training.credits' | translate }}:</label>
            <span class="columns-10 small-columns-12">{{ record.credits }}</span>
        </div>
        <div class="record-row app-grid" *ngIf="record.trainingProgram.hasCost">
            <label class="columns-2 small-columns-12">{{ 'training.cost' | translate }}:</label>
            <span class="columns-10 small-columns-12">{{ record.cost }}</span>
        </div>
        <div class="record-row app-grid" *ngIf="record.trainingProgram.hasResult">
            <label class="columns-2 small-columns-12">{{ 'training.result' | translate }}:</label>
            <span class="columns-10 small-columns-12">{{ record.result }}</span>
        </div>
        <div class="record-row app-grid" *ngIf="record.notes">
            <label class="columns-2 small-columns-12">{{ 'training.notes' | translate }}:</label>
            <span class="columns-10 small-columns-12">{{ record.notes }}</span>
        </div>
        <div class="record-row app-grid">
            <label class="columns-2 small-columns-12">{{ 'training.attachedFiles' | translate }}:</label>
            <span class="columns-10 small-columns-12">
                <span
                    *ngFor="let recordFile of record.trainingProgramRecordFiles"
                    class="file-link"
                    (click)="fileHelper.saveFile(recordFile.file)"
                    ><mat-icon [svgIcon]="recordFile.file.name | fileIcon"></mat-icon>{{ recordFile.file.name }}</span
                >
            </span>
        </div>
    </div>
    <div class="ui segment">
        <div class="app-grid">
            <h3 class="columns-12">
                <app-segment-header title="{{ 'training.trainingProgramDetails' | translate }}"></app-segment-header>
                <span class="record-status" *ngIf="getStatusMessage()">{{ getStatusMessage() | appTranslate }}</span>
            </h3>
            <div class="record-row app-grid">
                <label class="columns-2 small-columns-12">{{ 'training.dueDate' | translate }}:</label>
                <span class="columns-10 small-columns-12" *ngIf="record.dueAt; else hasNoDueDate">{{
                    record.dueAt | appDate
                }}</span>
                <ng-template #hasNoDueDate>
                    <span class="columns-10 small-columns-12">{{ 'training.noDueDate' | translate }}</span>
                </ng-template>
            </div>
            <div class="record-row app-grid">
                <label class="columns-2 small-columns-12">{{ 'training.description' | translate }}:</label>
                <span
                    class="columns-10 small-columns-12"
                    *ngIf="record.trainingProgram.description; else hasNoDescription"
                    [innerHTML]="record.trainingProgram.description | nl2br | sanitizeHtml"
                ></span>
                <ng-template #hasNoDescription>
                    <span class="columns-10 small-columns-12">{{ 'training.noDescription' | translate }}</span>
                </ng-template>
            </div>
            <div class="record-row app-grid" *ngIf="record.trainingProgram.isRecurring">
                <label class="columns-2 small-columns-12">{{ 'training.programRepeat' | translate }}:</label>
                <span class="columns-10 small-columns-12">
                    {{ record.trainingProgram.recurrenceLabel | appTranslate }}
                    <span *ngIf="record.trainingProgram.maxOccurrences">
                        {{
                            {
                                key: 'training.programEndsAfterNumberOfSessions',
                                params: { numberOfSessions: record.trainingProgram.maxOccurrences },
                            } | appTranslate
                        }}
                    </span>
                </span>
            </div>
            <div class="record-row app-grid">
                <label class="columns-2 small-columns-12">{{ 'training.attachedFiles' | translate }}:</label>
                <span class="columns-10 small-columns-12"
                    ><span
                        class="attachedFiles file-link"
                        *ngFor="let file of record.trainingProgram.files"
                        (click)="fileHelper.saveFile(file)"
                    >
                        <mat-icon [svgIcon]="file.name | fileIcon"></mat-icon>{{ file.name }}</span
                    >
                    <span class="columns-10 small-columns-12" *ngIf="!record.trainingProgram.files.length">{{
                        'training.noAttachedFiles' | translate
                    }}</span>
                </span>
            </div>
        </div>
    </div>
</div>
